// src/components/PrivacyPolicy.tsx - Privacy Policy display component  
import React from 'react';
import PageContainer from './PageContainer';

interface PrivacyPolicyProps {
  onBack: () => void;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ onBack }) => {
  return (
    <PageContainer 
      title="Privacy Policy" 
      onBack={onBack}
    >
          <section>
            <h2>1. Introduction</h2>
            <p>This Privacy Policy describes how we collect, use, and share information when you access our API and platform services ("Service"). By using the Service, you agree to the practices described in this Policy.</p>
          </section>
          <section>
            <h2>2. Information We Collect</h2>
            <p>We may collect the following categories of information:</p>
            <ul>
              <li>Contact information (e.g., name, email)</li>
              <li>Usage data (e.g., API requests, IP address, device info)</li>
              <li>Customer-submitted content via the API</li>
            </ul>
          </section>
          <section>
            <h2>3. How We Collect Information</h2>
            <p>We collect information:</p>
            <ul>
              <li>Directly from you when you create an account or use the Service</li>
              <li>Automatically via log data and analytics tools</li>
              <li>From third-party integrations you authorize</li>
            </ul>
          </section>
          <section>
            <h2>4. How We Use Information</h2>
            <p>We use the collected information to:</p>
            <ul>
              <li>Provide and maintain the Service</li>
              <li>Improve functionality and user experience</li>
              <li>Communicate with users</li>
              <li>Ensure security and legal compliance</li>
            </ul>
          </section>
          <section>
            <h2>5. Legal Basis for Processing</h2>
            <p>We process your data based on:</p>
            <ul>
              <li>Your consent</li>
              <li>Our legitimate interest in operating and improving the Service</li>
              <li>Legal obligations</li>
            </ul>
          </section>
          <section>
            <h2>6. Data Sharing</h2>
            <p>We may share your data with:</p>
            <ul>
              <li>Trusted service providers and subprocessors</li>
              <li>Government authorities when legally required</li>
              <li>Others, only with your explicit consent</li>
            </ul>
          </section>
          <section>
            <h2>7. User Rights</h2>
            <p>Depending on your location, you may have rights to:</p>
            <ul>
              <li>Access, correct, or delete your data</li>
              <li>Object to or restrict processing</li>
              <li>Withdraw consent</li>
            </ul>
            <p>To exercise these rights, contact us at joe@startwave.io</p>
          </section>
          <section>
            <h2>8. Data Retention</h2>
            <p>We retain your data as long as necessary to fulfill the purposes outlined in this Policy, unless a longer retention period is required by law.</p>
          </section>
          <section>
            <h2>9. Security</h2>
            <p>We implement technical and organizational measures to protect your information. However, no system is 100% secure.</p>
          </section>
          <section>
            <h2>10. International Transfers</h2>
            <p>Your information may be transferred and processed outside your country of residence, including in countries that may not have equivalent data protection laws.</p>
          </section>
          <section>
            <h2>11. Role as Data Controller</h2>
            <p>We act as a data controller when we determine the purposes of processing your personal data. For customer-submitted data, we may act as a data processor under applicable agreements.</p>
          </section>
          <section>
            <h2>12. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. The latest version will always be available on our website. Continued use of the Service constitutes acceptance of changes.</p>
          </section>
          <section>
            <h2>13. Contact Us</h2>
            <p>If you have questions or requests regarding this Privacy Policy, please contact us at: joe@startwave.io.</p>
          </section>
    </PageContainer>
  );
};

export default PrivacyPolicy; 